/*
  Ayni Ppacha V4 – Wischen in der Vollbild-Galerie der Produktseite
  (Blum: snippets/main-product-gallery-dialog.liquid → sht-gallery / sht-gallery-slides / sht-zoom)

  Blum zeigt im Vollbild immer nur ein Bild und blättert ausschließlich über die Pfeil-Buttons.
  Dieses Script ergänzt:
  - Wischen links/rechts (Touch) → löst die vorhandenen Blum-Buttons aus (Zähler, Zoom-Reset,
    Videos bleiben in Blums Logik). Das Bild folgt dem Finger und gleitet beim Wechsel herein.
  - Pfeiltasten ← → (Desktop: über die Thumbnails, Mobil: über die Buttons).
  - Ist ein Bild gezoomt (Antippen), wird nicht geblättert – dann verschiebt der Finger den Ausschnitt.
  Komplett delegiert: Der Dialog-Inhalt entsteht erst beim ersten Öffnen aus einem <template>.
*/
(function () {
  if (window.__apGallerySwipe) return;
  window.__apGallerySwipe = true;

  var DIALOG = 'sht-dialog[id^="dialogProductGallery"]';
  var SLIDES = 'sht-gallery-slides';
  var MIN_DISTANCE = 45;   // px
  var MAX_TIME = 900;      // ms
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Horizontale Gesten gehören der Galerie (sonst wertet der Browser sie u. U. als „Zurück“-Geste).
  // Gezoomt (.o-scroll) bleibt Verschieben in alle Richtungen erlaubt.
  var style = document.createElement('style');
  style.textContent =
    DIALOG + ' ' + SLIDES + ' { overscroll-behavior: none; }' +
    DIALOG + ' ' + SLIDES + ':not(.o-scroll) { touch-action: pan-y pinch-zoom; }';
  document.head.appendChild(style);

  function openDialog() {
    var dialogs = document.querySelectorAll(DIALOG);
    for (var i = 0; i < dialogs.length; i++) {
      if (!dialogs[i].hasAttribute('hidden')) return dialogs[i];
    }
    return null;
  }

  function activeSlide(root) {
    return root.querySelector('.js-gallery-slide.is-active-gallery-slide');
  }

  function isZoomed(root) {
    var slides = root.querySelector(SLIDES);
    if (slides && slides.classList.contains('o-scroll')) return true;
    var slide = activeSlide(root);
    return !!(slide && slide.querySelector('.js-zoom-item[zoomed]'));
  }

  function visible(el) {
    return !!(el && el.offsetParent !== null);
  }

  // Ein Bild weiter (dir = 1) oder zurück (dir = -1). Gibt true zurück, wenn gewechselt wurde.
  function go(root, dir) {
    var btn = root.querySelector(dir > 0 ? '.js-slide-next-btn' : '.js-slide-prev-btn');
    if (visible(btn)) {
      if (btn.disabled) return false;
      btn.click();
      return true;
    }
    // Desktop: Pagination ist ausgeblendet, Blum blättert dort über die Thumbnails
    var thumbs = Array.prototype.filter.call(root.querySelectorAll('.js-gallery-thumb'), visible);
    var current = -1;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active-gallery-thumb')) current = i;
    }
    var next = thumbs[current + dir];
    var nextBtn = next && next.querySelector('.js-gallery-btn-thumb');
    if (current < 0 || !nextBtn) return false;
    nextBtn.click();
    return true;
  }

  function slideIn(root, dir) {
    if (reduceMotion) return;
    var slide = activeSlide(root);
    var inner = slide && slide.firstElementChild;
    if (!inner || !inner.animate) return;
    inner.animate(
      [{ transform: 'translateX(' + dir * 24 + '%)', opacity: 0 }, { transform: 'none', opacity: 1 }],
      { duration: 240, easing: 'cubic-bezier(.2,.7,.2,1)' }
    );
  }

  function settle(inner) {
    if (!inner) return;
    if (!reduceMotion && inner.animate && inner.style.transform) {
      inner.animate(
        [{ transform: inner.style.transform }, { transform: 'none' }],
        { duration: 180, easing: 'ease-out' }
      );
    }
    inner.style.transform = '';
  }

  // --- Touch ---------------------------------------------------------------
  var start = null;

  document.addEventListener('touchstart', function (e) {
    start = null;
    if (e.touches.length !== 1) return;
    var root = openDialog();
    if (!root || !e.target.closest || !e.target.closest(DIALOG + ' ' + SLIDES)) return;
    if (e.target.closest('button')) return;
    if (isZoomed(root)) return;
    var slide = activeSlide(root);
    start = {
      root: root,
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
      t: Date.now(),
      inner: slide && slide.firstElementChild,
      axis: null
    };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!start || e.touches.length !== 1) return;
    var dx = e.touches[0].clientX - start.x;
    var dy = e.touches[0].clientY - start.y;
    if (!start.axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
      start.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    }
    if (start.axis === 'x' && start.inner && !reduceMotion) {
      start.inner.style.transform = 'translateX(' + dx * 0.5 + 'px)';
    }
  }, { passive: true });

  function end(e) {
    if (!start) return;
    var s = start;
    start = null;
    var touch = e.changedTouches && e.changedTouches[0];
    settleOrGo(s, touch ? touch.clientX - s.x : 0, touch ? touch.clientY - s.y : 0);
  }

  function settleOrGo(s, dx, dy) {
    var isSwipe = s.axis === 'x' &&
      Math.abs(dx) >= MIN_DISTANCE &&
      Math.abs(dx) > Math.abs(dy) * 1.5 &&
      Date.now() - s.t <= MAX_TIME;
    var dir = dx < 0 ? 1 : -1;
    if (isSwipe && go(s.root, dir)) {
      if (s.inner) s.inner.style.transform = '';
      slideIn(s.root, dir);
    } else {
      settle(s.inner);
    }
  }

  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', function () {
    if (start && start.inner) settle(start.inner);
    start = null;
  }, { passive: true });

  // --- Tastatur --------------------------------------------------------------
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var root = openDialog();
    if (!root || isZoomed(root)) return;
    var dir = e.key === 'ArrowRight' ? 1 : -1;
    if (go(root, dir)) {
      e.preventDefault();
      slideIn(root, dir);
    }
  });
})();